import { PoWiseOpCompletionModel } from "../po-wise-op-completion.model";


export class StyleWiseOpCompletionModel {
    style: string;
    poWiseCompletionStatus: PoWiseOpCompletionModel[];

    constructor(style: string, poWiseCompletionStatus: PoWiseOpCompletionModel[]) {
        this.style = style;
        this.poWiseCompletionStatus = poWiseCompletionStatus;
    }
}


